var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "CompassDialog",
    {
      attrs: {
        visible: _vm.isVisible,
        title: _vm.dialogTitle,
        size: "small",
        closeOnClickOverlay: false
      },
      on: {
        "update:visible": function($event) {
          _vm.isVisible = $event
        },
        closed: function($event) {
          return _vm.$emit("close")
        }
      }
    },
    [
      _c("template", { slot: "default" }, [
        _c("p", {
          staticClass:
            "typographies-paragraph-medium-regular activities-dialog__content",
          domProps: { innerHTML: _vm._s(_vm.dialogContent) }
        })
      ]),
      _vm._v(" "),
      _c(
        "section",
        {
          staticClass: "activity-delete-dialog-footer__container",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("CompassButton", {
            attrs: {
              type: "secondary",
              label: _vm.cancelButtonLabel,
              disabled: _vm.pending
            },
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          }),
          _vm._v(" "),
          _c("CompassButton", {
            attrs: {
              loading: _vm.pending,
              type: "primary-destructive",
              label: _vm.confirmButtonLabel
            },
            on: { click: _vm.onDelete }
          })
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }